/* @flow */
import React from 'react';
// $FlowIgnore
import { MdAssignmentTurnedIn } from 'react-icons/md';

export default function ReleasedIcon({
  style
}: Object): React.Element {
  return <MdAssignmentTurnedIn style={style} />;
}
